import { getVehicleInfoByLorryType, LORRY_CATEGORIES_ENUM } from "@vahak/core/dist/constants/lorryTypes";

import { CompactLoadPostingState } from "./types";

/** Body type id can be 0 (e.g. Open) — must not use truthy checks. */
export function isBodyTypeSelected(bodyType: number | null | undefined): boolean {
    return bodyType != null;
}

export function isTyreSelected(tyres: number | undefined): boolean {
    return tyres != null && tyres > 0;
}

export function isCompactSizeSelected(state: Pick<CompactLoadPostingState, "lorrySize">): boolean {
    return state.lorrySize != null && state.lorrySize > 0;
}

export function usesCapacityBasedSizeFlow(lorryType?: number): boolean {
    return (
        lorryType === LORRY_CATEGORIES_ENUM.CONTAINER ||
        lorryType === LORRY_CATEGORIES_ENUM.TRAILER ||
        lorryType === LORRY_CATEGORIES_ENUM.LCV
    );
}

export function getDefaultCompactSizeFields(
    lorryTypeId?: number
): Pick<CompactLoadPostingState, "lorrySize" | "sizeText" | "lorrySizeNoPreference"> {
    const vehicle = lorryTypeId ? getVehicleInfoByLorryType(lorryTypeId, "load") : undefined;
    const firstOption = vehicle?.feetOptions[0];

    if (!firstOption) {
        return {
            lorrySize: 0,
            sizeText: "",
            lorrySizeNoPreference: false
        };
    }

    return {
        lorrySize: firstOption.size ?? 0,
        sizeText: firstOption.sizeType ?? "",
        lorrySizeNoPreference: false
    };
}

export function resolveSizeFromFeetOptionId(
    lorryTypeId: number | undefined,
    optionId: number
): Pick<CompactLoadPostingState, "lorrySize" | "sizeText" | "lorrySizeNoPreference"> {
    const vehicle = lorryTypeId ? getVehicleInfoByLorryType(lorryTypeId, "load") : undefined;
    const selected = vehicle?.feetOptions.find((item) => item.id === optionId);

    return {
        lorrySize: selected?.size ?? 0,
        sizeText: selected?.sizeType ?? "",
        lorrySizeNoPreference: false
    };
}
